import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { QuestionAnswerProps } from './IFaq';

const QuestionAnswer: React.FC<QuestionAnswerProps> = ({
  containerStyle,
  faq,
  handleToggle,
  openId,
}) => {
  const isOpen = faq.faqId === openId;

  return (
    <button
      type="button"
      onClick={() => handleToggle(faq.faqId)}
      className={`${containerStyle} text-start`}
    >
      <div className="flex items-center justify-between">
        <div className="max-sm:w-[90%]">
          <h3
            className="font-inter text-blue-600 text-[16px] leading-[24px]
          sm:text-[20px] sm:leading-[30px] font-bold
        "
          >
            {faq.faqTitle}
          </h3>
        </div>
        <div className="text-blue-500 focus:outline-none h-full">
          {isOpen ? (
            <FontAwesomeIcon
              icon={faCircleMinus as IconProp}
              color="#8CAFCE"
              fontSize={'24'}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCirclePlus as IconProp}
              color="#8CAFCE"
              fontSize={'24'}
            />
          )}
        </div>
      </div>
      <div
        className={`mt-4 pt-4 text-start ${
          isOpen ? 'block' : 'hidden'
        } transition-all duration-1300`}
      >
        <p
          className="font-roboto text-stone-800 text-[14px] sm:text-[16px]
         sm:leading-[26.4px] leading-[23.1px] whitespace-pre-wrap"
        >
          {faq.faqText}
        </p>
      </div>
    </button>
  );
};

export default QuestionAnswer;
